import { render, staticRenderFns } from "./PrHoldOrNot.vue?vue&type=template&id=1ab616b6&"
import script from "./PrHoldOrNot.vue?vue&type=script&lang=js&"
export * from "./PrHoldOrNot.vue?vue&type=script&lang=js&"
import style0 from "./PrHoldOrNot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports